import styles from "./styles.module.scss";
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateDataset } from "../../../../redux/dataset/datasetSlice";

export default function TranscriptModerator() {
  const data = useSelector((state) => state.datasetSlice.dataset);
  const dispatch = useDispatch();
  const moderator = data.moderator;
  const [isEditable, setIsEditable] = useState(false);
  const moderatorField = useRef(null);
  const toggleEditable = () => {
    if (isEditable) {
      dispatch(updateDataset({ moderator: moderatorField.current.innerText }));
    }
    setIsEditable(!isEditable);
  };
  return (
    <div className={styles.moderatorWrapper}>
      <h3>Moderator</h3>
      <div
        className={
          isEditable
            ? `${styles.moderator} ${styles.editable}`
            : styles.moderator
        }
      >
        <span
          className={styles.moderatorName}
          contentEditable={isEditable}
          suppressContentEditableWarning={true}
          ref={moderatorField}
        >
          {moderator}
        </span>
        {data.transcript_status !== "COMPLETED" && (
          <img
            src={isEditable ? "/icons/check-mark.svg" : "/icons/blue-edit.svg"}
            alt="edit"
            className={
              isEditable ? `${styles.image} ${styles.submit}` : styles.image
            }
            onClick={toggleEditable}
          />
        )}
      </div>
    </div>
  );
}
